import React from "react";
import { Thead } from "./Thead";
import { Tbody } from "./Tbody";

import "./table.css";
export function Table(){
  return (
    <div className="container-table" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
      <section className="section-table">
        <table className="div_table">
          <Thead /><Tbody />
        </table>
      </section>
    </div>
  );
}
